<div id="site-contact" [formGroup]="form">
  <div class="p-2">
    <div class="row pb-2">
      <label class="col-3 mt-2 text-end mogo-bold" >Contact Name:</label>
      <div class="col-9 mt-1">
        <input type="text"
               formControlName="siteContact"
               class="form-control text-capitalize"
               placeholder="Contact" />
      </div>
    </div>

    <div class="row pb-2">
      <label class="col-3 mt-2 text-end mogo-bold" >Phone #:</label>
      <div class="col-9 mt-1">
        <input type="text"
               formControlName="sitePhone"
               class="form-control text-capitalize"
               placeholder="Phone" />
      </div>
    </div>

    <div class="row pb-2">
      <label class="col-3 mt-2 text-end mogo-bold" >Email:</label>
      <div class="col-9 mt-1">
        <input type="text"
          formControlName="siteEmail"
          class="form-control text-capitalize"
          placeholder="Email" />
          @if(isEmailInvalid()){
              <div class="text-start">
                <small class="text-danger">Please enter a valid email address</small>
              </div>
            }
      </div>
    </div>
</div>
</div>
